function initializeProductVideo(media) {
  if (media.dataset.initialized) return;

  const video = media.querySelector('video');
  if (!video) return;

  media.dataset.initialized = 'true';

  media.addEventListener('mouseenter', () => {
    video.controls = true;
  });

  media.addEventListener('mouseleave', () => {
    video.controls = false;
  });
}

function initializeProductVideos(container = document) {
  container.querySelectorAll('.product-instagram-reel__media').forEach(initializeProductVideo);
}

document.addEventListener('DOMContentLoaded', () => initializeProductVideos());
document.addEventListener('shopify:section:load', (event) => initializeProductVideos(event.target));
